/**
 * Backend signals lead capture via SSE metadata:
 * { type: "metadata", request_visitor_info: true }
 */
export function metadataRequestsVisitorInfo(
  data: Record<string, unknown> | null | undefined
): boolean {
  if (!data) return false;
  return Boolean(
    data.request_visitor_info === true ||
      data.collect_visitor_info === true ||
      data.show_visitor_form === true ||
      data.action === "request_visitor_info"
  );
}
